import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Table } from 'reactstrap';
import getContributors from '../../api/getContributors';
import removeProjectUser from '../../api/removeProjectUser';
import AddUserModal from './components/AddUserModal';
import UserModal from './components/UserModal';
import Loader from '../../pages/utilities/loader';

const UserManagement = () => {
    const selectedProject = useSelector(state => state.selectedProject);
    const { isLoading, data: contributors, refetch } = useQuery("getContributors" + selectedProject.name, () => getContributors(selectedProject.name))
    const [showModal, setShowModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);

    const [selectedUser, setSelectedUser] = useState({});

    const handleClose = () => setShowModal(false);
    const handleAddClose = () => setShowAddModal(false);

    const handleOpen = (user) => {
        setSelectedUser(user)
        setShowModal(true);
    }
    const handleAddOpen = () => setShowAddModal(true);

    const handleDeleteUser = async (user) => {
        await removeProjectUser(selectedProject.name, user)
        refetch()
    }

    if (isLoading) return <><Loader /></>

    return (
        <div className="recent-activities form-documents">
            <UserModal selectedUser={selectedUser} show={showModal} handleClose={handleClose} />
            <AddUserModal refetch={refetch} show={showAddModal} handleClose={handleAddClose} />
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="border-0 m-0">Gestion des utilisateurs</h3>
                <button onClick={handleAddOpen} className="add-btn"><i className="ti-plus"></i> Ajouter utilisateur</button>
            </div>
            <Table>
                <thead>
                    <tr>
                        <th>Nom utilisateur</th>
                        <th className="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {contributors.data.map(user => {
                        const { username } = user;
                        return <tr>
                            <td>{username}</td>
                            <td className="text-center">
                                <button onClick={() => handleOpen(user)} className="edit-btn download-btn" title="Vue"><i className="ti-eye"></i></button>
                                <button onClick={() => handleDeleteUser(username)} className="remove-btn" title="Supprimer"><i className="ti-trash"></i></button>
                            </td>
                        </tr>
                    }
                    )}
                </tbody>
            </Table>
        </div>
    );
}

export default UserManagement;